import { useEffect, useState } from 'react';
import { FileManagerService } from './file_manager.service';
import type { FileWorker } from './file_worker/mod';

export function useFileWorkerList(fileManager: FileManagerService): Readonly<FileWorker[]> {
	const [, forceUpdate] = useState([]);

	useEffect(() => {
		return fileManager.events.on('onFileWorkerUpdate', () => {
			forceUpdate([]);
		});
	}, [fileManager]);

	return fileManager.peakWorkerList();
}
